<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-11 13:56:59
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\warehouse\components\addOrEdit.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-dialog v-loading.fullscreen="loading" :append-to-body="true" :title="warehouseInfo.id ? '编辑仓库' : '新增仓库'"
    :visible="visible" width="450px" :destroy-on-close="true" :wrapper-closable="false" :show-close="false"
    :close-on-press-escape="false" :close-on-click-modal="false">
    <el-form ref="form" :rules="rules" :model="form" label-width="120px">
      <el-form-item label="仓库名称" prop="name">
        <el-input v-model.trim="form.name" style="width: 200px;" maxlength="20" placeholder="请输入仓库名称"></el-input>
      </el-form-item>
      <el-form-item label="仓库编码" prop="code">
        <el-input v-model="form.code" :disabled="form.id" style="width: 200px;" maxlength="20"
          placeholder="请输入仓库编码"></el-input>
      </el-form-item>
      <el-form-item label="仓库地址" prop="address">
        <el-input v-model="form.address" style="width: 200px;" maxlength="100" placeholder="请输入仓库地址"></el-input>
      </el-form-item>
      <el-form-item label="仓库负责人" prop="chargeUserName">
        <el-input v-model="form.chargeUserName" style="width: 200px;" maxlength="20" placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-form-item label="负责人电话" prop="chargeUserTel">
        <el-input v-model="form.chargeUserTel" style="width: 200px;" placeholder="请输入内容"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit"> 确 定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  updateWarehouse,
} from '@/api/warehouse'
import { addWarehouse } from '../../../api/warehouse'
export default {
  name: 'AddOrEditWarehouse',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    warehouseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      form: {},
      rules: {
        name: [
          {
            required: true,
            message: '请输入仓库名称',
            trigger: ['change', 'blur']
          }
        ],
        code: [
          {
            required: true,
            message: '请输入仓库编码',
            trigger: ['change', 'blur']
          }
        ],
        address: [
          {
            required: true,
            message: '请输入仓库地址',
            trigger: ['change', 'blur']
          }
        ],
        chargeUserTel: [{
          pattern: /^(?:(?:\+?86)?1[3-9]\d{9}|0[1-9]\d{1,2}-?\d{7,8})$/,
          message: '请输入正确的电话格式',
          trigger: ['change', 'blur']
        }]
      }
    }
  },
  created() {
    if (this.warehouseInfo.id) {
      this.form = JSON.parse(JSON.stringify(this.warehouseInfo))
    }
  },
  // 方法集合
  methods: {
    // 保存
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.loading = true
        const params = JSON.parse(JSON.stringify(this.form));
        params.name = params.name.trim()
        if (params.id) {
          updateWarehouse(params).then(() => {
            this.$emit('close')
          }).finally(() => {
            this.loading = false
          })
        } else {
          addWarehouse(params).then(() => {
            this.$emit('close')
          }).finally(() => {
            this.loading = false
          })
        }

      })
    }
  }
}
</script>
